import {useEffect} from "react";
import {useLocation} from "react-router-dom";

import getPageName from "../helpers/getPageName";

const usePageEventAnalytics = () => {
  const {pathname} = useLocation();

  useEffect(() => {
    const pageName = getPageName(pathname);

    window.analytics?.page(pageName);
  }, [pathname]);
};

export default usePageEventAnalytics;
